// @flow
import Promise from 'bluebird';
import _ from 'lodash';

import api from '../../api';
import ColorBrewer from '../../core/tools/colorbrewer';
import environment from '../../environment';
import ShapesAfterSalesControl from './ShapesAfterSalesControl';
import infoBoard from '../../core/infoboard';

export class SelectedAreasAfterSalesControl extends ShapesAfterSalesControl {
    constructor() {
        const options = {
            id: 'area-selection',
            name: 'SelectedAreasAfterSales',
            types: environment.get('CONFIG.FILTERS.AREAS_TYPES'),
            themes: environment.get('CONFIG.FILTERS.AREAS_THEMES'),
            filter: true,
            overview: true,
            request: api.afterSales.get.themes
        };

        super(options);

        (this).colorize = this.colorize.bind(this);
        (this).select = this.select.bind(this);
    }

    static getInstance() {
        if (!SelectedAreasAfterSalesControl._instance) {
            SelectedAreasAfterSalesControl._instance = new SelectedAreasAfterSalesControl();
        }

        return SelectedAreasAfterSalesControl._instance;
    }

    select(value = this.getTypeValue(true), options) {
        if (!options || _.isString(options)) {
            options = {
                remote: {
                    method: 'GET',
                    url: `${environment.get('API_HOST')}/aftersales/locales/areas`,
                    params: {
                        locationType: value
                    }
                }
            };
        }

        this.getControls().slider.opacity.input.enable(true);
        this.getControls().slider.opacity.enable = true;

        super.select(value, options);
    }

    colorize(featureCollection, layer) {
        return new Promise((resolve) => {
            const id = layer.getMap()._id;

            if (!this.getControls(id).dropdown.data) {
                return resolve(featureCollection);
            }

            super.colorize(featureCollection, layer)
                .then(res => {
                    if (this._checkThemes(['socialClass'])) {
                        res.features = res.features.filter(x => x.properties.Total !== 0);
                    }

                    this.setThemeLayerOptions();

                    resolve(res);
                });
        });
    }

    setThemeLayerOptions() {
        const options = this.getLayer().options;
        if (this._checkThemes(['socialClass'])) {
            this.getControls().button.filter.input.enable(false);
            this.getControls().button.filter.enable = false;
            this.getControls().button.overview.input.enable(false);
            this.getControls().button.overview.enable = false;
            this.getControls().slider.range.input.enable(false);
            this.getControls().slider.range.enable = false;
            this.getControls().colorpicker.fillColor.input.value('Set2:6');
            this.getControls().colorpicker.fillColor.value = 'Set2:6';
            options.symbology.scale = 'nomenal';
            options.symbology.theme = ColorBrewer.Set2['6'];

            infoBoard.toggleDataboard(false, 0);
            infoBoard.toggleFilter(false);
        } else {
            this.getControls().colorpicker.fillColor.input.enable(true);
            this.getControls().colorpicker.fillColor.enable = true;
            options.symbology.scale = 'jenks';
            options.symbology.theme = ColorBrewer.OrRd[9];
        }
        this.getLayer().setOptions(options);
    }
}

export default SelectedAreasAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/SelectedAreasAfterSalesControl.js